<template lang='pug'>
v-app#app(v-if='route.path.toLowerCase().includes("/logout")')
    v-main.v-main-upgpt-login()
        router-view(@loginSuccess='loginSuccess')    
v-app#app(v-else-if='route.query.next && route.query.next.includes("/upmeeting") || route.path.includes("/upmeeting")')
    v-main(class="v-main_meeting" )
        router-view(@loginSuccess='loginSuccess')
v-app#app(v-else-if='route.path.toLowerCase().includes("/sso-tsc-login")')
    v-main.v-main-upgpt-login()
        router-view(@loginSuccess='loginSuccess')
v-app#app(v-else-if='route.path.toLowerCase().includes("/sso-upgpt-login")')
    v-main.v-main-upgpt-login()
        router-view(@loginSuccess='loginSuccess')        
v-app#app(v-else-if='route.path.toLowerCase().includes("/upgpt-login")')
    v-main.v-main-upgpt-login()
        router-view(@loginSuccess='loginSuccess')
v-app#app(v-else-if='route.path.toLowerCase().includes("/docs")')
    v-main.v-main-upgpt-login()
        router-view(@loginSuccess='loginSuccess')        
v-app#app.TenantCenter(v-else-if='route.path.toLowerCase().includes("/tenant_center")')
    MenuBarTenantCenter()
    v-main.v-main-upgpt-login()
        router-view(@loginSuccess='loginSuccess')
v-app#app(v-else-if='route.path.toLowerCase().includes("/image_url")')
    v-main.v-main-disply-img(:class="route.path === '/login' ? 'login-page':''" v-if='$route.meta.showMenu != false')
        router-view(@loginSuccess='loginSuccess' :member='member')
v-app#app.UpPortal(@logoutSuccess='logoutSuccess' v-else-if='route.path.toLowerCase().includes("/upgpt_portal")')
    .v-main-portal(:class="route.path === '/login' ? 'login-page':''" v-if='$route.meta.showMenu != false')
        router-view(@loginSuccess='loginSuccess' :member='member')
v-app#app.UrbanRenewalAdmin(v-else-if='isUrbanRenewalRoute')
    //- 登入頁：bare（無 shell）
    v-main.v-main-urbanrenewal(v-if='isUrbanRenewalLoginRoute')
        router-view(@loginSuccess='loginSuccess')
    //- 其餘 admin 頁：包 UrbanRenewalAdminLayout shell
    UrbanRenewalAdminLayout(v-else)
        router-view(@loginSuccess='loginSuccess')
v-app#app.UrbanRenewalSelect(v-else-if='isUrbanRenewalSelectRoute')
    //- 登入/忘記/重設：bare（無 shell）
    v-main.v-main-urbanrenewal(v-if='isUrbanRenewalSelectBareRoute')
        router-view(@loginSuccess='loginSuccess')
    //- 其餘：包 UrbanRenewalSelectLayout
    UrbanRenewalSelectLayout(v-else)
        router-view(@loginSuccess='loginSuccess')
v-app#app(v-else-if='!route.path.toLowerCase().includes("/upgpt")')
    NoticeBoard(v-if='member.userid != "" && noticeBoard_isclose == false && $route.meta.showMenu != false')
    MenuBar(@logoutSuccess='logoutSuccess' :member='member' v-if='$route.meta.showMenu != false')
    v-main(:class="route.path === '/login' ? 'login-page':''" v-if='$route.meta.showMenu != false')
        router-view(@loginSuccess='loginSuccess')
    v-main(:class="route.path === '/login' ? 'login-page':'v-main_empty'" v-else)
        router-view(@loginSuccess='loginSuccess')
v-app#app(v-else)
    MenuBarGpt(@logoutSuccess='logoutSuccess' :member='member' v-if='$route.meta.showMenu != false')
    v-main.v-main-gpt(@logoutSuccess='logoutSuccess' :class="route.path === '/login' ? 'login-page':''" v-if='$route.meta.showMenu != false')
        router-view(@loginSuccess='loginSuccess')
</template>

<script>
import NoticeBoard from '@/layout/NoticeBoard.vue';
import MenuBar from '@/layout/MenuBar.vue';
import MenuBarGpt from '@/layout/MenuBarGpt.vue';
import MenuBarPortal from "@/layout/MenuBarPortal.vue";
import MenuBarTenantCenter from "@/layout/MenuBarTenantCenter.vue";
import UrbanRenewalAdminLayout from "@/layout/UrbanRenewalAdminLayout.vue";
import UrbanRenewalSelectLayout from "@/layout/UrbanRenewalSelectLayout.vue";
import { mapActions, mapState } from 'vuex';

export default {
    name: 'App',
    components: {
        NoticeBoard,
        MenuBar,
        MenuBarGpt,
        MenuBarPortal,
        MenuBarTenantCenter,
        UrbanRenewalAdminLayout,
        UrbanRenewalSelectLayout,
    },
    data() {
        return {
            member: this.getLoginUserInfo(),
            noticeBoard_isclose: this.checkNoticeIsClosed()
        };
    },
    computed: {
        route() {
            return this.$route;
        },
        // 都更後台版面判斷用「實際網址」而非 $route.path。
        // 因為 urbanRenewalAdminGuard 是非同步守衛（要 await preference API），
        // 在守衛解析完成前 $route.path 仍是起始的 '/'，會先算成 CRM 版面（MenuBar 閃一下）。
        // window.location.pathname 在首次繪製就是正確的，避免閃版。
        isUrbanRenewalRoute() {
            return this.effectivePath.includes('/urbanrenewal/admin');
        },
        isUrbanRenewalLoginRoute() {
            return this.effectivePath.includes('/urbanrenewal/admin/login');
        },
        // 都更前台選配（地主）版面判斷，與 admin 分支互斥（路徑不同：/urbanrenewal/select）。
        isUrbanRenewalSelectRoute() {
            return this.effectivePath.includes('/urbanrenewal/select');
        },
        isUrbanRenewalSelectBareRoute() {
            return ['/urbanrenewal/select/login', '/urbanrenewal/select/forgot', '/urbanrenewal/select/reset']
                .some(p => this.effectivePath.includes(p));
        },
        effectivePath() {
            const rp = (this.$route && this.$route.path) || '/';
            const path = (rp === '/' && typeof window !== 'undefined')
                ? window.location.pathname
                : rp;
            return path.toLowerCase();
        },
        ...mapState(['isLoggedIn']),
    },
    methods: {
        handleLogout(event) {
            event.preventDefault();
            this.logout();
            this.$router.push('/');
        },
        loginSuccess() {
            this.member = this.getLoginUserInfo();
        },
        logoutSuccess() {
            this.member = this.getLoginUserInfo();          
        },
        getLoginUserInfo() {
            var user = window.localStorage.getItem('user');
            let userObj = null;
            if (user == null || user == undefined) 
                userObj = { userid: '' };
            else {
                let obj = JSON.parse(user);
                
                userObj = {
                    userid: obj.userid,
                    name: [obj.last_name, obj.first_name].join(' '),
                    pic: obj.pic? obj.pic:'',
                    nickname: [obj.last_name.charAt(0), obj.first_name.charAt(0)].join(''),
                    is_service_agent: obj.is_service_agent,
                    is_tech_user: obj.is_tech_user,
                    is_portal_user: obj.is_portal_user,
                    is_view_only_user: obj.is_view_only_user,
                    status: obj.status
                }
                this.$isViewOnly.isViewOnly = obj.is_view_only_user;
            }
            return userObj;
        },
        checkNoticeIsClosed() {
            this.noticeBoard_isclose = true
            if(window.localStorage.getItem('NoticeBoard_IsClose') == null){
                return false;
            }
            return window.localStorage.getItem('NoticeBoard_IsClose');
        },  
        ...mapActions(['logout']),
    },
    created() {
        // Only fetch (auth-required) on-prem settings when logged in. Firing
        // these authRequest calls while unauthenticated triggers a 401 →
        // refresh-fail → logout → hard redirect to /login, which kicks users
        // off public pages such as the Urban Renewal admin login. Defaults
        // (azure_acs / web search enabled) are kept until a session exists.
        if (window.localStorage.getItem('access_token')) {
            this.$store.dispatch('fetchOnPremSettings');
        }
    },
    watch :{
        $route (to, from){
            if(from.fullPath == "/UpChat"){
                document.body.classList.remove('chat_hide_scroll_bar')
            }
        }
    }
};
</script>

<style lang="scss">
@import '~normalize.css/normalize.css';
@import 'style/allview'; //共用的all.scss
</style>